var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"margin-left":"5px"}},[_c('el-tooltip',{attrs:{"placement":"right","title":"","width":"460","trigger":"hover","enterable":false,"effect":"light"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('el-image',{attrs:{"src":_vm.img}})],1),_c('i',{staticClass:"el-icon-info",staticStyle:{"margin-left":"0"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }